export const REDIRECT = 'redirect';
export const AUTH_TOKEN = 'auth-token';
export const CONNECTION_SID = 'connection-sid';
